<template>
	<div id="app-create-progress-bar">
		
		<div class="stages">

					<router-link 
	            active-class="panel-active" 
	            :to="{ path : '/create/select-area'}" 
	            exact
	            class="panel"
							ref="link0"
	        >
	          <span class="panel__subhead">Step one</span>
	          <span>Where?</span>
	        </router-link>

	        <router-link 
	            active-class="panel-active" 
	            :to="{ path : '/create/area-details'}" 
	            exact
	            class="panel"
							ref="link1"
	        >
	          <span class="panel__subhead">Step Two</span>
	          <span>What?</span>
	        </router-link>
					
					<router-link 
	            active-class="panel-active" 
	            :to="{ path: '/create/review-areas'}" 
	            exact
	            class="panel"
							ref="link2"
	        >
	          <span class="panel__subhead">Step Three</span>
	          <span>Review</span>
	        </router-link>

					<router-link 
	            active-class="panel-active" 
	            :to="{ path : '/login-or-register' }" 
	            
	            class="panel"
							ref="link3"
	        >
	          <span class="panel__subhead">Step Four</span>
	          <span>Who?</span>
	        </router-link>

	       	<router-link 
	            active-class="panel-active" 
	            :to="{ path: '/create/quote-summary'}" 
	            exact
	            class="panel"
							ref="link4"
	        >
	          <span class="panel__subhead">Step Five</span>
	          <span>Your quote</span>
	        </router-link>

		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>
	export default {
		methods : {
			boBack(){
				let links = this.$refs;
				// loop through all the refs above
				Object.keys(links).map((key, i) => {
					// find one with an active className
					if(links[key].$el.className.match('panel-active')){
						// if not the first link then use the index to go back one
						if(key !== 'link0'){
							this.$router.push({path : links['link' + (i - 1)].to.path})
						}	
					}
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Create/CreateProgressBar.vue